module.exports = __webpack_public_path__ + "img/exploding_head.6b150afc.gif";